import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useNotifications } from '@sequencehq/core-components'
import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { NotificationPolicySettings } from 'SettingsV2/components/notifications/NotificationsPolicySettings'
import { WebhookCreatedModal } from 'SettingsV2/components/notifications/webhookCreated.modal'

export const WebhooksNewSettingsPage: FC = () => {
  const { displayNotification } = useNotifications()
  const navigate = useNavigate()

  // The signing secret is only returned when the webhook is created, so we
  // hold the created policy here to surface it immediately instead of making
  // the user dig it out of the kebab menu afterwards.
  const [createdWebhook, setCreatedWebhook] = useState<{
    webhookSecret?: string
  } | null>(null)

  const mutator = useMutation(dashboard20240730Client.postNotificationPolicy, {
    onSuccess: data => {
      if (!data) return
      // The confirmation modal is the success signal here so the user can copy
      // the secret; an additional toast would be redundant and duplicate copy.
      setCreatedWebhook({ webhookSecret: data.webhookSecret })
    },
    onError: () => {
      displayNotification(`Failed to create Webhook`, {
        type: 'error'
      })
    }
  })

  return (
    <>
      <NotificationPolicySettings
        channel="WEBHOOK"
        header="Create new webhook"
        isPending={mutator.isPending}
        onSubmit={formData => {
          mutator.mutate({
            name: formData.name,
            recipients: formData.recipients,
            notificationTypes: formData.notificationTypes,
            channel: 'WEBHOOK'
          })
        }}
      />

      <WebhookCreatedModal
        isOpen={Boolean(createdWebhook)}
        webhookSecret={createdWebhook?.webhookSecret}
        onClose={() => navigate('/settings/webhooks')}
      />
    </>
  )
}
